import React, { useState } from "react";
import { rateStar, rateStarActive } from "../../assets/svgs";
import styles from "./style.module.css";

interface ReviewStarsProps {
  totalStars?: number;
  initialRating?: number;
  onChange?: (rating: number) => void;
  readOnly?: boolean;
}

export const RateStars: React.FC<ReviewStarsProps> = ({
  totalStars = 5,
  initialRating = 0,
  onChange,
  readOnly = false,
}) => {
  const [rating, setRating] = useState(initialRating);
  const [hover, setHover] = useState(0);

  const handleClick = (value: number) => {
    if (readOnly) return;
    setRating(value);
    if (onChange) onChange(value);
  };

  return (
    <div
      className={`${styles.container} ${readOnly ? styles.readOnly : ""}`}
    >
      {Array.from({ length: totalStars }, (_, i) => {
        const starValue = i + 1;
        const isActive = starValue <= (hover || rating);

        return (
          <img
            key={starValue}
            src={isActive ? rateStarActive : rateStar}
            alt="star"
            className={styles.star}
            onClick={() => handleClick(starValue)}
            onMouseEnter={() => !readOnly && setHover(starValue)}
            onMouseLeave={() => !readOnly && setHover(0)}
          />
        );
      })}
    </div>
  );
};
